import React, { useEffect, useState } from 'react';
import { Col, Row, Alert, Button, Form, Modal } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { schedulePaymentActionCreators } from '../../store/SchedulePaymentStore';
import { CheckWrapper } from '.././CheckWrapper';
import { checkNullOrUndefined } from '../../functions/dcrGlobal';
import ContributionSummary from '.././ContributionSummary';
import { DisplayBankInfo } from '../DisplayBankInfo';
import { helperActionCreators, Permissions } from '../../store/HelperStore';
import { accountActionCreators } from '../../store/AccountStore';
import { stateNeedsLoading } from '../../functions/stateNeedsLoading';
import { historyActionCreators } from '../../store/HistoryStore';
import { PaymentAccountDrowDownProps } from '../PaymentAccountDropDown';
import { hasPermission } from '../../functions/hasPermission';

type TContributionCancelPaymentProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContributionCancelPayment = (props: TContributionCancelPaymentProps) => {

    const allowCancelPayment = hasPermission(Permissions.ContributionDetails_Cancel, props.currentUserPermissions);

    const [checked, setChecked] = useState(false);
    const [isSubmitClick, setIsSubmitClick] = useState(false);
    const [totalContribution, setTotalContribution] = useState("");
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(allowCancelPayment);
    const [isShowAlertBox, setIsShowAlertBox] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [isErrorOrWarning, setIsErrorOrWarning] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedValue, setSelectedValue] = useState("")
    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        props.fetchCMSelectedBank(props.cmCancelPayment.ccaId, true);
        const total = props.cmCancelPayment.cmContribs.find(x => x.name === "Total Contributions:")?.value;
        setTotalContribution(total ? total : "")
    }, []);


    const getFilterValue = (val: string) => {
        return val.replace("$", "").replace(",", "");
    }

    useEffect(() => {
        if (props.cmCancelPayment.cmContribs.length !== 0 && parseInt(getFilterValue(totalContribution)) !== 0
            && parseInt(selectedValue) !== 0 && checked && allowCancelPayment) {
            setDisableSubmitBtn(false);
        }
        else {
            setDisableSubmitBtn(true)
        }
    }, [props.cmCancelPayment.cmContribs, selectedValue, checked, totalContribution])

    useEffect(() => {

        if (props.cmCancelPayment.isSelectedBankLoaded) {
            setSelectedValue(props.cmCancelPayment?.cmSelectedBankInfo?.selected)
        }
    }, [props.cmCancelPayment.isSelectedBankLoaded]);

    const getPaymentAccounts = () => {
        if (props.ownProps.parentPaymentAccounts) {
            return props.ownProps.parentPaymentAccounts
        }
        if (!(props.ownProps.parentPaymentAccounts) && props.accounts.isLoaded) {
            return props.accounts.cmAccounts?.pay_sources
        }
        return null;
    }

    const [paymentAccounts, setPaymentAccounts] = useState(getPaymentAccounts());

    useEffect(() => {
        if (checkNullOrUndefined(props.ownProps.parentPaymentAccounts)) {
            if (stateNeedsLoading(props.accounts)) {
                props.fetchBankInfo(props.dcr?.selectedInstitution);
            }
            else if (props.accounts.isLoaded && !props.accounts.error) {
                setPaymentAccounts(props.accounts.cmAccounts?.pay_sources);
            }
        }
    })

    useEffect(() => {
        if (props.accounts.isLoaded && !props.accounts.error) {
            setPaymentAccounts(props.accounts.cmAccounts?.pay_sources);
        }
    }, [props.accounts.isLoaded])

    useEffect(() => {
        setShowDetails(parseInt(selectedValue) > 0);
        if (props.ownProps.onChange) {
            props.ownProps.onChange(paymentAccounts?.find(x => (x.sequence === parseInt(selectedValue))));
        }
    }, [selectedValue])

    useEffect(() => {
        if (props.cmCancelPayment.isPaymentLoaded) {
            setAlertMessage(props.cmCancelPayment?.cmPaymentUpdateInfo?.paymentinfo?.message)
            setIsShowAlertBox(true)
            setAlertTitle('Contribution Management')
        }
        if (props.cmCancelPayment.isPaymentUpdateError) {
            setIsErrorOrWarning(true)
            setErrorMessage("Error occured while performing cancel schedule payment.Reason :" + props.cmCancelPayment.paymentUpdateErrorMsg)
        }
    }, [props.cmCancelPayment.isPaymentLoaded])

    function generateXML() {
        const rawXml = "<SchedulePayment  cca_id='#cca_id#' payment_date='#pmtDate#' forfeiture_amount='#amt_forfeiture#' final_funding_amount='#amt_finalfunding#'/>";
        const cca_id = props.cmCancelPayment?.ccaId;
        const payment_date = "";
        const amt_forfeiture = "0.0";
        const amt_finalfunding = "0.0";
        const xmlData = rawXml.replace("#cca_id#", cca_id)
            .replace("#pmtDate#", payment_date)
            .replace("#amt_forfeiture#", amt_forfeiture)
            .replace("#amt_finalfunding#", amt_finalfunding);
        return xmlData;
    }

    const validCancelDate = () => {
        const d1 = new Date().getDate();
        const parts1 = props.cmCancelPayment?.scheduleDate.split('/');
        const d2 = parseInt(parts1[1]);
        const h1 = new Date().getHours();
        const h2 = 15;

        if (d1 === d2) {
            if (h1 >= h2)
                return false;
            else
                return true;
        }
        return true;
    }

    const successSchedulePayment = () => {
        // props.fetchCMHistory(props.selectedUmcId, false)
        setIsShowAlertBox(false);
        setErrorMessage("");
        setIsErrorOrWarning(false);
        setIsShowAlertBox(false);
        setAlertMessage("");
        setAlertTitle("");
        props.fetchCMHistory(props.selectedUmcId, false, false);
        props.resetAllStateAndRedirectToHistory();
    }

    const submitClick = () => {
        if (!validCancelDate()) {
            setIsShowAlertBox(true)
            setAlertMessage("Payment cannot be cancelled because it is after 3:00 p.m., Central on the 'Send Payment On' date.")
            setAlertTitle("Contribution Management")
            return;
        }
        if (!disableSubmitBtn && checked) {
            setErrorMessage("")
            setIsErrorOrWarning(false)
            setIsShowAlertBox(false)
            props.fetchCMPaymentUpdate(generateXML(), "")
        }
    }
    const cancelClick = () => {
        props.resetAllStateAndRedirectToDetails();
    }

    return (
        <>
            <Row style={{ padding: "1.2%" }}>
                <Col>
                    <Row className="tbl-info-wrap">
                        <Col className="">
                            <h4 className="float-left">Cancel Payment of Contributions</h4>
                        </Col>
                    </Row>
                    {isErrorOrWarning &&
                        <Alert className="mt-2" variant="danger">
                            <Row>
                                <Col>
                                    {errorMessage}
                                </Col>
                            </Row>
                        </Alert>
                    }
                    {props.cmCancelPayment.isWespathInfoError &&
                        <Alert className="mt-2" variant="danger">
                            <Row>
                                <Col>
                                    Error occured while getting Wespath BankInfo.
                                </Col>
                            </Row>
                        </Alert>
                    }
                    <Row className="px-3">
                        <Col className="col-12 col-md-5">
                            <div>
                                <Row>
                                    <Col className="my-2">
                                        <h6>Contribution Summary for {props.cmCancelPayment.statusDate} </h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="pl-4">
                                        <ContributionSummary />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col className="col-12 col-md-6">
                            <Row className="ml-sm-2 mt-3 mt-sm-0">
                                <Col className="my-2 ">
                                    {showDetails &&
                                        <h6> {paymentAccounts ? paymentAccounts?.find(x => (x.sequence === parseInt(selectedValue)))?.acct_type?.toLowerCase() === "wespath" ? "Payment Source" : "Bank ACH Information" : ""} </h6>
                                    }
                                </Col>
                            </Row>
                            {!props.cmCancelPayment.isSelectedBankLoaded && <LoadingSkeletonForBankInfo />}
                            {(props.cmCancelPayment.isSelectedBankLoaded && showDetails && parseInt(selectedValue) > 0) && <>
                                <Row>
                                    <Col className="pl-4">
                                        <DisplayBankInfo pmtAccount={paymentAccounts?.find(x => (x.sequence === parseInt(selectedValue)))} />
                                    </Col>
                                </Row>
                            </>}
                        </Col>
                    </Row>
                    <hr />
                    <Form.Group>
                        <Row className="mt-2 px-3">
                            <Col className="col-12 col-md-6">
                                <div className="form-group">
                                    <Form.Label className="control-label">Current Payment Date:</Form.Label>
                                    <span className="ml-3 control-value ">
                                        {props.cmCancelPayment.scheduleDate}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Row className="mt-4">
                        <CheckWrapper>
                            <Form.Check className={"ml-4 control-value "} custom onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setChecked(e.target.checked) }} checked={checked} id="chk_agree" type="checkbox" value="Y" label="Cancel the payment of contributions for this date.  I will reschedule this payment." />
                        </CheckWrapper>
                    </Row>
                    {!checked && isSubmitClick &&
                        <Alert className="mt-2" variant="danger">
                            <Row>
                                <Col>
                                    Please confirm your intent to cancel this payment by checking the box above.
                                </Col>
                            </Row>
                        </Alert>
                    }
                    <hr />
                    {props.cmCancelPayment.isPaymentLoding && <LoadingSkeletonForButtons />}
                    {!props.cmCancelPayment.isPaymentLoding &&

                        <Row>
                            <Col>
                                <div className="mt-1 pt-3 mb-5">
                                    <Button className="btn-block-xs-only float-right btn btn-primary" variant="primary" disabled={disableSubmitBtn}
                                        onClick={() => {
                                            submitClick(); setIsSubmitClick(true);
                                        }}>Submit</Button>
                                    <Button onClick={() => { cancelClick(); }} className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary"
                                        variant="secondary">Cancel</Button>
                                </div>
                            </Col>
                        </Row>
                    }
                    <Modal show={isShowAlertBox} backdrop="static" centered >
                        <Modal.Header>
                            <Modal.Title>{alertTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-justify">
                            <Row>
                                <Col className="mx-2">
                                    {alertMessage}
                                </Col>
                            </Row>
                        </Modal.Body>
                        <div className="border-top mt-4 p-3">
                            <>
                                <Button className="btn-block-xs-only float-right" variant="primary"
                                    onClick={() => { !validCancelDate() ? cancelClick() : successSchedulePayment(); }}>Ok
                                </Button>
                            </>
                        </div>
                    </Modal>
                </Col>
            </Row>
        </>
    )
}
const LoadingSkeletonForButtons = () => (
    <div className="row">
        <Col className="col-12 col-sm-2 col-md-4 col-lg-8 d-none d-sm-block"></Col>
        <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
            <div className="mt-1"><Skeleton width={'100%'} /></div>
        </Col>
        <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
            <div className="mt-1"><Skeleton width={'100%'} /></div>
        </Col>
    </div>
);

const LoadingSkeletonForBankInfo = () => (
    <div className="row">
        <div className="col-7">
            <div className="row">
                <div className="col-6">
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'240%'} /></div>
                </div>
                <div className="col-6">
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                    <div className="mt-2 col-6"><Skeleton width={'220%'} /></div>
                </div>
            </div>
        </div>
    </div>
);

function mapStateToProps(state: AppState, paymentAccountDrowDownProps: PaymentAccountDrowDownProps) {
    return {
        cmCancelPayment: state.cmSchedulePayment,
        dcr: state.dcr,
        currentUser: state.dcr.currentuserInfo?.user,
        accounts: state.accounts,
        currentUserPermissions: state.dcr.currentuserInfo?.user?.permissions,
        ownProps: paymentAccountDrowDownProps,
        selectedUmcId: state.dcr.selectedInstitution
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...schedulePaymentActionCreators, ...historyActionCreators, ...accountActionCreators, ...helperActionCreators
        }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContributionCancelPayment);